import React from 'react'
import FloorListTable from './Components/FloorListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const FloorList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Floor List</HeadingOne>
                    <AddItemBtn url="add-floor" title="Add Floor" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <FloorListTable />
            </div>
        </PageBody>
    );
};

export default FloorList;
